import React, { useContext, useState } from "react";
import { Box, Button } from "@mui/material";
import { useMutation } from "@apollo/client";
import { CURRENT_USER, DELETE_USER } from "../../graphql/gqlUser";
import { SnackbarContext } from "../../contexts/snackbarContext";
import { T } from "../../components/T";
import { AreYouSureModal } from "../../modals/AreYouSureModal";

const DeleteAccount = () => {
  const { openSuccessSnackbar, openErrorSnackbar } =
    useContext(SnackbarContext);

  const [deleteUser] = useMutation(DELETE_USER, {
    refetchQueries: [{ query: CURRENT_USER }],
  });

  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDelete = () => {
    deleteUser()
      .then(() => {
        openSuccessSnackbar(<T str="Account deleted" />);
      })
      .catch((error: Error) => {
        openErrorSnackbar(error.message || <T str="Something went wrong" />);
      })
      .finally(() => {
        setDialogOpen(false);
      });
  };

  return (
    <>
      <Box sx={{ mt: 1 }}>
        <Button
          variant="contained"
          color="error"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => setDialogOpen(true)}
        >
          <T str="Delete account" />
        </Button>
      </Box>

      <AreYouSureModal
        title={<T str="Confirm account deletion" />}
        question={
          <T str="Are you sure you want to delete your account? This action is permanent and cannot be undone." />
        }
        confirm={<T str="Delete" />}
        onConfirm={handleDelete}
        open={dialogOpen}
        setOpen={setDialogOpen}
      />
    </>
  );
};

export default DeleteAccount;
